import { Component, ViewEncapsulation, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

export interface LogoItem {
  src: string;
  alt: string;
  /**
   * Intrinsic dimensions. Required by NgOptimizedImage in Plan 03.
   * SVG logos still receive numeric values (even though the loader bypasses
   * them) so the component can bind `[width]`/`[height]` unconditionally.
   * Zero indicates missing media.
   */
  width?: number;
  height?: number;
  href?: string;
}

@Component({
  selector: 'ds-logo-block',
  templateUrl: './logo-block.html',
  styleUrl: './logo-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [NgOptimizedImage],
})
export class LogoBlockComponent {
  readonly logos = input.required<LogoItem[]>();
  readonly heading = input<string>();
}
